module.exports = __webpack_public_path__ + "img/Icon2.3c270bc2.svg";